import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "../features/login/loginSlice";
import machinesReducer from "../features/machines/machinesSlice";
import mappingsReducer from "../features/iotmappings/mappingsSlice";
import productsReducer from "../features/product/productSlice";
// import recipesReducer from '../features/recipes/recipesSlice';

import loginService from "../features/login/loginAPI";
import machinesService from "../features/machines/machinesAPI";
import mappingsService from "../features/iotmappings/mappingsAPI";
import productsService from "../features/product/productAPI";
// import recipesService from "../features/recipes/recipesAPI";


import {
  rtkErrorLogger,
  rtkMutationSuccessLogger,
} from "../middlewares/rtkLogger";

export const store = configureStore({
  reducer: {
    loginReducer,
    machinesReducer,
    mappingsReducer,
    productsReducer,
    // recipesReducer,
    
    [loginService.reducerPath]: loginService.reducer,
    [machinesService.reducerPath]: machinesService.reducer,
    [mappingsService.reducerPath]: mappingsService.reducer,
    [productsService.reducerPath]: productsService.reducer,
    // [recipesService.reducerPath]: recipesService.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(rtkErrorLogger)
      .concat(rtkMutationSuccessLogger)
      .concat(loginService.middleware)
      .concat(machinesService.middleware)
      .concat(mappingsService.middleware)
      .concat(productsService.middleware)
      // .concat(recipesService.middleware),
      
});
